import { ExperimentalFeaturesRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/experimental-features')({
  component: ExperimentalFeaturesRoute,
});
